import { render } from "./DashboardTopSales.vue?vue&type=template&id=3b546e8f&ts=true"
import script from "./DashboardTopSales.vue?vue&type=script&lang=ts"
export * from "./DashboardTopSales.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__